import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SectionItemComponent } from '../../../sections-list/section-card/section-options/section-item/section-item.component';

@Component({
    selector: 'signer-options',
    templateUrl: 'signer-options.component.html',
    styleUrl: 'signer-options.component.scss',
    imports: [CommonModule, SectionItemComponent, TranslatePipe],
})
export class SignerOptionsComponent {
    public isHidden = input(true);
    public close = output<void>();
    public edit = output<void>();
    public remove = output<void>();
}
